import { deleteAiModel, getActiveAiModel, getAllAimodels, updateAiModel } from "Config/API/get";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import './AssetChatbot.css';
import { aifileid, currentselectedfiledata } from "Redux/action/variable.action";
import { useDispatch } from "react-redux";
import { FaTrash } from "react-icons/fa";
const AiAssistant = ({ onClose }) => {
  const [models, setModels] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const fetchData = async () => {
    try {
      setLoading(true);
      const [modelsRes, activeRes] = await Promise.all([
        getAllAimodels(token),
        getActiveAiModel(token),
      ]);

      if (modelsRes?.status) {
        setModels(modelsRes.data.models || []);
      }
      if (activeRes?.status && activeRes.data.model) {
        setSelectedModelId(activeRes.data.model.id);
      }
    } catch (err) {
      console.error("Error fetching AI models", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {


    fetchData();
  }, [token]);
  const dispatch = useDispatch();
  const handleUpdate = async () => {
    if (!selectedModelId) {
      toast.error("Please select a model first");
      return;
    }

    try {
      setLoading(true);
      const res = await updateAiModel(token, selectedModelId);
      if (res?.status) {
        dispatch(aifileid(""));

        dispatch(currentselectedfiledata(""));
        toast.success("Model updated successfully!");
        onClose();
      } else {
        toast.error(res?.message || "Failed to update model");
      }
    } catch (err) {
      console.error("Error updating AI model", err);
    } finally {
      setLoading(false);
    }
  };
  const [deleteTarget, setDeleteTarget] = useState(null); // modelId to delete
const [showDeleteModal, setShowDeleteModal] = useState(false);
const confirmDelete = async () => {
  if (!deleteTarget) return;

  try {
    setLoading(true);
    const res = await deleteAiModel(token, deleteTarget);
    console.log({res})
    if (res?.data?.status) {
      toast.success("Model deleted successfully!");
      fetchData();
    } else {
      toast.error(res?.data?.message || "Failed to delete model");
    }
  } catch (err) {
    console.error("Error deleting AI model", err);
  } finally {
    setLoading(false);
    setShowDeleteModal(false);
    setDeleteTarget(null);
  }
};

  

  return (
    <div className="aiassistant-overlay" onClick={onClose}>
      <div className="aiassistant-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="aiassistant-title">Select AI Model</h2>

        {loading ? (
          <div className="aiassistant-loading">
            <div className="spinner"></div>
          </div>
        ) : models.length > 0 ? (
          <div className="aimodelassitant">
         <div className="aiassistant-model-list">
  {models.map((model) => (
    <label key={model.id} className="aiassistant-model-item">
      <div className="model-info">
        <input
          type="radio"
          name="ai-model"
          value={model.id}
          checked={selectedModelId === model.id}
          onChange={() => setSelectedModelId(model.id)}
        />
        <div>
          <p className="model-name">{model.model_name}</p>
          <p className="model-description">{model.description}</p>
        </div>
      </div>

      <FaTrash
        className="delete-icon"
        style={{ cursor: "pointer", color: "grey" }}
       onClick={(e) => {
    e.stopPropagation(); // prevent radio/label click
    setDeleteTarget(model.id);
    setShowDeleteModal(true);
  }}
      />
    </label>
  ))}
</div></div>

        ) : (
          <p className="no-models">No models available</p>
        )}

        <div className="aiassistant-buttons">
          <button className="cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="update-btn" onClick={handleUpdate} disabled={loading}>
            {loading ? "Update" : "Update"}
          </button>
        </div>
      </div>
      {showDeleteModal && (
  <div className="delete-modal-overlay" onClick={() => setShowDeleteModal(false)}>
    <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
      <h3>Delete Model</h3>
      <p>Are you sure you want to delete this model?</p>
      <div className="modal-buttons">
        <button
          className="cancel-btn"
          onClick={() => setShowDeleteModal(false)}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="delete-btn"
          onClick={confirmDelete}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </button>
      </div>
    </div>
  </div>
)}

    </div>
    
  );
};

export default AiAssistant;
